// extracted by mini-css-extract-plugin
module.exports = {"image":"Scene7Image_image__TKGvo"};